module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_c('br', {
    staticClass: "calibre17",
    attrs: {
      "id": "calibre_pb_3"
    }
  }), _c('span', {
    staticClass: "calibre18"
  }, [_vm._v("The Jewel of the Kingdom by Roy Dimond and Lorraine Dimond")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("Copyright © 2019. All rights reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('img', {
    staticClass: "calibre20",
    attrs: {
      "alt": "",
      "src": "images/00001.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("ALL RIGHTS RESERVED:  No part of this book may be reproduced, stored, or transmitted, in any form, without the express and prior permission in writing of Pen It! Publications.  This book may not be circulated in any form of binding or cover other than that in which it is currently published.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("   This book is licensed for your personal enjoyment only.  All rights are reserved.  Pen It! Publications does not grant you rights to resell or distribute this book without prior written consent of both Pen It! Publications and the copyright owner of this book.  This book must not be copied, transferred, sold or distributed in any way.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("   Disclaimer:  Neither Pen It! Publications, or our authors will be responsible for repercussions to anyone who utilizes the subject of this book for illegal, immoral or unethical use. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("   This is a work of fiction. The views expressed herein do not necessarily reflect that of the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("   This book or part thereof may not be reproduced in any form, stored in a retrieval system, or transmitted in any form by any means-electronic, mechanical, photocopy, recording or otherwise-without prior written consent of the publisher, except as provided by United States of America copyright law.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('img', {
    staticClass: "calibre21",
    attrs: {
      "alt": "",
      "src": "images/00001.jpeg"
    }
  }), _c('img', {
    staticClass: "calibre22",
    attrs: {
      "alt": "",
      "src": "images/00002.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("Published by Pen It! Publications, LLC")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("812-371-4128   ")]), _c('a', {
    attrs: {
      "href": "http://www.penitpublications.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "calibre23"
  }, [_vm._v("www.penitpublications.com")])]), _c('span', {
    staticClass: "calibre19"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('img', {
    staticClass: "calibre24",
    attrs: {
      "alt": "",
      "src": "images/00001.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("ISBN:  978-1-952011-30-6")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("Edited by Peggy Holt")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre19"
  }, [_vm._v("Cover Design by Donna Cook")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre25"
  }, [_c('span', {
    staticClass: "calibre16",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06da1061","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_002.vue
// module id = 66
// module chunks = 0